export default {
  axisLine: {
    show: true,
    lineStyle: {
      color: '#ffffff'
    }
  },
  axisTick: {
    show: true,
    lineStyle: {
      color: '#ffffff'
    }
  },
  axisLabel: {
    show: true,
    textStyle: {
      color: '#999999'
    }
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: ['#eeeeee']
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};